document.addEventListener("DOMContentLoaded", function () {
  // only on desktop widths
  if (window.innerWidth >= 750) {
    document
      .querySelectorAll(".facets__panel[open]")
      .forEach((panel) => panel.removeAttribute("open"));
  }
});
